module.exports = __webpack_public_path__ + "img/iveco.d8f467d6.svg";